export const CUSTOMER_STAGE_LABEL_OVERRIDES: Record<string, string> = {
  PRICING: "Paid",
  COMPLETED: "Filed",
};
